<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      finish-button-text="Submit"
      back-button-text="Previous"
      class="wizard-vertical mb-3"
      @on-complete="formSubmitted"
    >
      <!-- Store datails tab -->
      <tab-content title="รายละเอียดร้าน">
        <b-row>
          <b-col cols="5" class="mb-2">
            <!-- <b-avatar :src="pictrue" size="144px" rounded /> -->
          </b-col>
          <b-col md="5"> </b-col>
          <b-col md="2">
            <div class="demo-inline-spacing">
              <!-- primary -->
              <div>
                <b-card-text class="mb-0"> เปิดใช้งาน </b-card-text>
                <b-form-checkbox
                  v-model="status"
                  checked="true"
                  class="custom-control-primary"
                  name="check-button"
                  switch
                />
              </div>
            </div>
          </b-col>
          <!-- <b-col md="2">
            <b-form-file
              ref="file-input"
              size="sm"
              v-model="file"
              class="mb-2"
              type="file"
              accept=".jpeg,.png,.jpg,GIF"
              :hidden="true"
              @change="onFileChange"
            />เลือกรูปภาพร้าน
          </b-col> -->
          <b-col cols="12" class="mb-2"> </b-col>

          <b-col md="6">
            <b-form-group label="ชื่อสาขา" label-for="name">
              <b-form-input v-model="name" id="name" placeholder="ชื่อสาขา" />
              <b-alert v-if="check.name == true" variant="danger" show>
                <span>Please Enter</span>
              </b-alert>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="หมายเลขโทรศัพท์" label-for="phone">
              <b-form-input
                v-model="phone"
                id="phone"
                placeholder="หมายเลขโทรศัพท์"
                type="number"
              />
              <b-alert v-if="check.phone == true" variant="danger" show>
                <span>Please Enter</span>
              </b-alert>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="ละติจูด ลองจิจูด" label-for="address">
              <b-form-input
                readonly
                id="address"
                v-model="address"
                placeholder="ละติจูด ลองจิจูด"
              />
            </b-form-group>
          </b-col>
         

          <b-col cols="12" class="mb-2"> แผนที่</b-col>
          <b-col md="12">
            <gmap-map
              :zoom="14"
              :center="center"
              style="width: 100%; height: 350px"
              @click="handleMapClick"
            >
              <gmap-marker :position="position"> </gmap-marker>
            </gmap-map>
          </b-col>
        </b-row>
      </tab-content>

      <!-- เวลาเปิดทำการ -->
      <!-- <tab-content title="เวลาเปิดทำการ">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">เวลาเปิดทำการ</h5>
          </b-col>
         
          <b-col md="6">
            <b-form-group label="Sunday Start" label-for="sunday_start">
              <b-form-timepicker
                v-model="sunday_start"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Sunday End" label-for="sunday_end">
              <b-form-timepicker
                v-model="sunday_end"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
         
          <b-col md="6">
            <b-form-group label="Monday Start" label-for="monday_start">
              <b-form-timepicker
                v-model="monday_start"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Monday End" label-for="monday_end">
              <b-form-timepicker
                v-model="monday_end"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
         
          <b-col md="6">
            <b-form-group label="Tuesday Start" label-for="tuesday_start">
              <b-form-timepicker
                v-model="tuesday_start"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Tuesday End" label-for="tuesday_end">
              <b-form-timepicker
                v-model="tuesday_end"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
        
          <b-col md="6">
            <b-form-group label="Wednesday Start" label-for="wednesday_start">
              <b-form-timepicker
                v-model="wednesday_start"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Wednesday End" label-for="tuesday_end">
              <b-form-timepicker
                v-model="tuesday_end"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
         
          <b-col md="6">
            <b-form-group label="Thursday Start" label-for="thursday_start">
              <b-form-timepicker
                v-model="thursday_start"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Thursday End" label-for="tuesday_end">
              <b-form-timepicker
                v-model="tuesday_end"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
        
          <b-col md="6">
            <b-form-group label="Friday Start" label-for="friday_start">
              <b-form-timepicker
                v-model="friday_start"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Friday End" label-for="friday_end">
              <b-form-timepicker
                v-model="friday_end"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
          
          <b-col md="6">
            <b-form-group label="Saturay Start" label-for="saturay_start">
              <b-form-timepicker
                v-model="saturay_start"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Saturay End" label-for="saturay_end">
              <b-form-timepicker
                v-model="saturay_end"
                size="lg"
                local="en"
                class="mb-2"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content> -->
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";

import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BAvatar,
  BFormFile,
  BFormSelect,
  BFormTimepicker,
  BFormCheckbox,
  BAlert,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { gmapApi } from "vue2-google-maps";
import api from "@/api";
export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormCheckbox,
    BAvatar,
    BFormFile,
    BFormSelect,
    BFormTimepicker,
    BFormCheckbox,
    BAlert,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    google: gmapApi,
  },
  data() {
    return {
      store_name: "",
      pictrue: null,
      name: null,
      phone: null,
      address: null,
      file: null,
      status: true,
      center: { lat: 16.439688394027236, lng: 102.8289296386659 },
      position: { lat: 16.439688394027236, lng: 102.8289296386659 },
      sunday_start: "09:00",
      sunday_end: "18:00",
      monday_start: "09:00",
      monday_end: "18:00",
      tuesday_start: "09:00",
      tuesday_end: "18:00",
      wednesday_start: "09:00",
      wednesday_end: "18:00",
      thursday_start: "09:00",
      thursday_end: "18:00",
      friday_start: "09:00",
      friday_end: "18:00",
      saturay_start: "09:00",
      saturay_end: "18:00",
      check: {
        name: false,
        phone: false,
        selected: false,
      },
    };
  },
  mounted() {
    if (!localStorage.getItem("store_id")) {
      this.$swal({
        title: "กรูณาเลือกร้านค้าก่อน!",
        icon: "warning",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
      this.$router.push({ name: "store" });
    }
    this.store_name = localStorage.getItem("store_name");
    this.getoahotspot();
  },
  methods: {
    onFileChange(e) {
      this.file = e.target.files[0];
      console.log("file", this.file);
      const image = e.target.files[0];
      this.pictrue = URL.createObjectURL(image); ///show
    },

    formSubmitted() {
      console.log("formSubmit update");
      var access_token = localStorage.getItem("accessToken");
      var userData = localStorage.getItem("userData");
      console.log("access_token :>> ", access_token);
      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("id", this.id);
      formData.append("store_id", localStorage.getItem("store_id"));
      formData.append("name", this.name);
      formData.append("phone", this.phone);
      formData.append("lat", this.position.lat);
      formData.append("lng", this.position.lng);
      formData.append("status", this.status);
      formData.append("sunday_start", this.sunday_start);
      formData.append("sunday_end", this.sunday_end);
      formData.append("monday_start", this.monday_start);
      formData.append("monday_end", this.monday_end);
      formData.append("tuesday_start", this.tuesday_start);
      formData.append("tuesday_end", this.tuesday_end);
      formData.append("wednesday_start", this.wednesday_start);
      formData.append("wednesday_end", this.wednesday_end);
      formData.append("thursday_start", this.thursday_start);
      formData.append("thursday_end", this.thursday_end);
      formData.append("friday_start", this.friday_start);
      formData.append("friday_end", this.friday_end);
      formData.append("saturay_start", this.saturay_start);
      formData.append("saturay_end", this.saturay_end);


      if (this.name && this.phone) {
        this.$swal({
          title: "คุณต้องการบันทึกข้อมูล?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "บันทึกข้อมูล!",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            api
              .post("/addbrachbystore", formData, {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("accessToken"),
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                console.log("response", response);
                if (response) {
                  this.$swal({
                    icon: "success",
                    title: "success",
                    showConfirmButton: false,
                    timer: 3000,
                  });
                  this.$router.push("/store/detail");
                }
              });
          }
        });
      } else {
        if (!this.name) {
          this.check.name = true;
          console.log("this.check.name :>> ", this.check.name);
        }
        if (!this.phone) {
          this.check.phone = true;
          console.log("this.check.phone :>> ", this.check.phone);
        }

        this.$swal({
          title: "Error!",
          text: " ตรวจสอบข้อมูลใหม่อีกครั้ง!",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }

      const params = {
        store_id: localStorage.getItem("store_id"),
        user_main: userData.user_main,
        name: this.name,
        phone: this.phone,
        lat: this.position.lat,
        lng: this.position.lng,
        file: this.file,
        status: this.status,
        sunday_start: this.sunday_start,
        sunday_end: this.sunday_end,
        monday_start: this.monday_start,
        monday_end: this.monday_end,
        tuesday_start: this.tuesday_start,
        tuesday_end: this.tuesday_end,
        wednesday_start: this.wednesday_start,
        wednesday_end: this.wednesday_end,
        thursday_start: this.thursday_start,
        thursday_end: this.thursday_end,
        friday_start: this.friday_start,
        friday_end: this.friday_end,
        saturay_start: this.saturay_start,
        saturay_end: this.saturay_end
      };
      
    },
    // ---------------mapp ----------
    handleMapClick(e) {
      this.position.lat = e.latLng.lat();
      this.position.lng = e.latLng.lng();
      this.address = String(e.latLng.lat()) + " , " + String(e.latLng.lng());
      // console.log("e :>> ", e);

      // var geocoder = new google.maps.Geocoder();
      // var latlng = { lat: 1.39, lng: 103.8 };
      // geocoder.geocode({ location: latlng }, function (results, status) {
      //   if (status === "OK") {
      //     if (results[1]) {
      //       alert(results[1].formatted_address);
      //     } else {
      //       window.alert("No results found");
      //     }
      //   }
      // });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

